import Text from "./input/text";
import {useState} from "react";
import {UseForm} from "../hooks/UseForm";
import {Badge} from "react-bootstrap";

const formDefinition = {tag_name: ''}

export const AllowTags = ({image, isLoading, initialState = [], title, description, onChange}) => {
    const [error, setError] = useState('')
    const [allowed, setAllowed] = useState(initialState)
    const {formState: {tag_name}, onInputChange, onReset} = UseForm(formDefinition)


    const handleSubmit = (ev) => {
        ev.preventDefault();
        const pattern = /^[a-zA-Z-_$][a-zA-Z0-9-_$]*$/

        if(tag_name?.length === 0){
            setError('Please type a header name');
            return;
        }


        if(allowed.includes(tag_name)){
            setError('Header already exists');
            return;
        }


        if(!pattern.test(tag_name)){
            setError('Invalid header name');
            return;
        }


        const allowedTags = [...allowed, tag_name];
        setAllowed(allowedTags)
        onChange(allowedTags)
        setError('');
        onReset();
    }


    const deleteKey = (key_name) => {
        const filtered = allowed.filter(item => (item !== key_name));
        setAllowed(filtered)
        onChange(filtered)
    }



    return <div className="allow-tags d-flex align-items-center justify-content-center flex-column">
        <img alt="allow fields" className="img-cover" src={image}/>
        <h6>{title}</h6>
        <p>{description}</p>
        <div className="form-group d-block w-100">
            <form onSubmit={handleSubmit} autoComplete="off">
                <Text
                    label="Header"
                    size="sm"
                    name="tag_name"
                    isReady={!isLoading}
                    className="d-block"
                    value={tag_name}
                    error={error}
                    onChange={onInputChange}
                    placeholder="Type the key and press enter..."
                />
            </form>

            <div className="allowed-tags d-flex flex-wrap">
                {allowed.length > 0 && allowed.map(item => {
                    return <Badge key={item} className="me-1 mb-1 has-close" bg="default">{item}
                        <span className="close" onClick={ev => deleteKey(item)}>x</span>
                    </Badge>
                })}
            </div>
        </div>
    </div>
}